import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router";
import SplashLoading from "../../components/SplashLoading";
import useUserContext from "../../contexts/UserContext";
import Button from "../../styles/Button";
import ContentWrapper from "../../styles/ContentWrapper";
import HeroHeader from "../../styles/HeroHeader";
import { BACKGROUND_COLOR } from "../../styles/Theme";
import { UserStatusEnum } from "../../types/user";
import PrivacyPolicy from "./PrivacyPolicy";

type TermsProps = {
	hideActionButtons?: boolean;
};

function Actions() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { considerTerms, user } = useUserContext();

	async function accept() {
		await considerTerms(true);
		navigate(
			!user?.active || (user && user.active === UserStatusEnum.Pending) ? "/register/profile" : "/account/profile"
		);
	}

	async function decline() {
		await considerTerms(false);
		navigate("/logout");
	}

	return (
		<Box sx={{ position: "fixed", bottom: 0, width: "100%", bgcolor: "rgb(255, 255, 255, 0.8)" }}>
			<Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 2 }}>
				<Button color="primary" variant="contained" onClick={accept}>
					<Typography variant="h5" component="span">
						{t("accept")}
					</Typography>
				</Button>
				<Button color="secondary" variant="outlined" onClick={decline}>
					{t("cancel")}
				</Button>
			</Box>
		</Box>
	);
}

export function TermsPage({ hideActionButtons = false }: TermsProps) {
	const { user, isLoading } = useUserContext();

	if (isLoading) {
		return <SplashLoading />;
	}

	if (user?.termsAccepted) {
		const userHasAccounts = user.accounts.length > 0;

		return (
			<Navigate
				to={
					user.active === UserStatusEnum.Pending
						? "/register/profile"
						: !userHasAccounts
						? "/accounts/create"
						: "/accounts/"
				}
				replace={true}
			/>
		);
	}

	return (
		<Box minHeight="100vh" display="flex" flexDirection="column" bgcolor={BACKGROUND_COLOR}>
			<HeroHeader />
			<Box component="main" sx={{ flex: 1, py: { sm: 6, xs: 0 }, px: { sm: 4, xs: 0 } }}>
				<ContentWrapper sx={{ pb: { xs: 10 } }}>
					<TermsOfUse />
				</ContentWrapper>
			</Box>
			{!hideActionButtons && <Actions />}
		</Box>
	);
}

function TermsOfUse() {
	// TODO: #1428 Get Terms content from backend
	return <PrivacyPolicy />;
}

export default TermsOfUse;
